// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-document-type-list {
  max-height: 180px;
  overflow-y: auto;
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  background: var(--ui-input-bg);
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.add-document-type-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: var(--ui-radius-sm);
  margin: 0;
  cursor: pointer;
  font-weight: 500;
}

.add-document-type-option:hover {
  background: rgba(3, 78, 162, 0.06);
}

.add-document-type-option input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin: 0;
}

.add-document-type-help {
  display: block;
  margin-top: 6px;
  font-size: 13px;
  color: var(--texto-cinza, #6b7280);
}

.add-document-type-empty {
  margin: 4px 2px;
  font-size: 14px;
  color: var(--texto-cinza, #6b7280);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Internos/addDocument.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,kCAAkC;EAClC,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kCAAkC;EAClC,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC","sourcesContent":[".add-document-type-list {\n  max-height: 180px;\n  overflow-y: auto;\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  background: var(--ui-input-bg);\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.add-document-type-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  border-radius: var(--ui-radius-sm);\n  margin: 0;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.add-document-type-option:hover {\n  background: rgba(3, 78, 162, 0.06);\n}\n\n.add-document-type-option input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n}\n\n.add-document-type-help {\n  display: block;\n  margin-top: 6px;\n  font-size: 13px;\n  color: var(--texto-cinza, #6b7280);\n}\n\n.add-document-type-empty {\n  margin: 4px 2px;\n  font-size: 14px;\n  color: var(--texto-cinza, #6b7280);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
